import gql from 'graphql-tag'

export default gql`mutation updateEditUserExpenses($data: ProjectExpenseInput!, $user_id: Int!, $is_paid: Int) {
    updateEditUserExpenses(data: $data, user_id: $user_id, is_paid: $is_paid) @client
}`